import { API_BASE } from 'constants/apis';
import { getData, postData } from './index';

export const hoge = 'hoge';

export const requestCreateCompany = async (
  name: string,
  demoParam: boolean,
  xCSRFToken: string,
) => {
  const url = `${API_BASE}/backyard/companies`;
  let body = `name=${encodeURIComponent(name)}`;
  if (typeof demoParam === 'boolean') body += `&demo=${demoParam}`;
  const response = await postData(url, body, xCSRFToken);
  return response;
};

export const requestSearchCompanies = async (
  searchWord: string,
  searchDemoParams: boolean,
  searchStatus: 'active' | 'inactive',
  pageNumber?: number,
) => {
  let url = `${API_BASE}/backyard/companies?`;
  if (searchWord) url += `&keyword=${encodeURIComponent(searchWord)}`;
  if (typeof searchDemoParams === 'boolean') url += `&demo=${searchDemoParams}`;
  if (searchStatus) url += `&status=${searchStatus}`;
  if (pageNumber) url += `&page=${pageNumber}&limit=20`;
  const response = await getData(url);
  return response;
};
